import axios from '@/api/config';
const schedulePeriod={
  pageList(data){
      return  axios.post(`${process.env.BASE_URL}/schedulePeriod/pageList`, data);
  },
  addSchedulePeriod(data){
    return  axios.post(`${process.env.BASE_URL}/schedulePeriod/addSchedulePeriod`, data);
  },
  getSchedulePeriod(data){
    return  axios.get(`${process.env.BASE_URL}/schedulePeriod/getSchedulePeriod`, {params:data});
  },
  deleteSchedulePeriod(data){
    return  axios.delete(`${process.env.BASE_URL}/schedulePeriod/deleteSchedulePeriod`, {data:data});
  },
  updateSchedulePeriod(data){
    return  axios.put(`${process.env.BASE_URL}/schedulePeriod/updateSchedulePeriod`, data);
  },
}
export default schedulePeriod



// WEBPACK FOOTER //
// ./src/api/schedulePeriod.js